export default queryParams => {
  if (!Array.isArray(queryParams.status)) {
    return false;
  }

  const validSortBys = ["Value_Desc", "Value_Asc", "Opened_Desc", "Opened_Asc"];

  if (!validSortBys.includes(queryParams.sortBy)) {
    return false;
  }

  return true;
};
